'use strict';

const React = require( 'react' );
const classNames = require( 'classnames' );
const LocationDropDown = require( './location-dropdown.jsx' );
const RoomSelect = require( './rooms-dropdown.jsx' );
const FlightLookUp = require( './flightLookUp.jsx' );
const EngineHelper = require( './engineHelper.js' );
const SearchButton = require( './searchButton.jsx' );
const DateHelper = require( '../../../../../_plugins/lib/dateHelper.js' );
const Helpers = require( '../../../../../_plugins/lib/helpers.js' );
const propTypes = require('prop-types');
const HiddenInputs = require( './hiddenInputs.jsx' );
const { string, object, bool } = propTypes;
const createReactClass = require('create-react-class');

const HotelParkingEngine = createReactClass({
  mixins: [EngineHelper, Helpers],

  getInitialState() {
    return {
      ppts: 0,
      hiddenInputs: {}
    };
  },

  propTypes: {
    Location: string,
    domainSettings: object,
    formSettings: object,
    agentSettings: object,
    ArrivalDate: propTypes.instanceOf(Date),
    DepartDate: propTypes.instanceOf(Date),
    engineSearchField: string,
    hiddenLocation: string,
    agentData: object,
    selected: string,
    locations: object,
    roomTypeSelected: string,
    RoomTypes: object.isRequired,
    pageData: object,
    showFlight: bool
  },

  getDefaultProps() {
    return {
      hiddenLocation: '',
      engineSearchField: '',
      ArrivalDate: DateHelper.alterDateByNumberOfDays( new Date( ), 1 ),
      DepartDate: DateHelper.alterDateByNumberOfDays( new Date( ), 9 ),
      selected: 'hcp',
      showFlight: true
    };
  },

  componentDidMount( ) {
    this.getHiddenInputs( );
    this.updatePPTS( );
  },

  /**
  * Get the name of the page the user is currently on
  * @returns {string} - The name of the page with the .html extension, if on the home page returns an empty string.
  */
  getFullPageName () {
    const { pageData: { pageName } } = this.props
    return pageName !== 'index' ? `${pageName}.html` : ''
  },

  updatePPTS( ) {
    // Hacky but only way to currently wait for localStorage to update
    setTimeout( ( ) => {
      if ( this._pptsSelect && this._pptsSelect.value === '1' ) {
        this.setState({
          ppts: true
        });
      }
    }, 500 );
  },

  flipPPTS( ) {
    const { ppts } = this.state;
    this.setState({
      ppts: !ppts
    });
  },

  render() {
    const {
      Location,
      domainSettings,
      ArrivalDate,
      DepartDate,
      engineSearchField,
      hiddenLocation,
      agentData,
      selected,
      locations,
      formSettings,
      roomTypeSelected,
      RoomTypes,
      showFlight
    } = this.props;
    const defaultRoomType = roomTypeSelected || formSettings.defaultRoomType;
    const pagesName = this.getFullPageName();
    const { agent, typeRID, groupCode } = agentData;
    const arrivalDate = DateHelper.formatDateToDMY( ArrivalDate );
    const departDate = DateHelper.formatDateToDMY( DepartDate );
    const arrivalDateFormatted = DateHelper.formatDateToDddMMyy( ArrivalDate );
    const departDateFormatted = DateHelper.formatDateToDddMMyy( DepartDate );
    const activeClass = classNames({
      'active': selected === 'hcp',
      'hcp': true,
      'engine': true
    });

    const { ppts, hiddenInputs } = this.state;
    let arrivalDateText = 'Hotel and Parking check-in';
    let departDateText = 'Collect car on (parking for 1 car only)';
    if ( ppts ) {
      arrivalDateText = 'Parking from';
      departDateText = 'Hotel check-in (parking for 1 car only)';
    }

    const defaultInputs = {
      agentgroup: groupCode,
      channel: typeRID,
      agent: agent,
      product: 'hcp',
      selectProduct: 'hcp',
      request: '21',
      Nights: '1',
      numCarParking: '1',
      Referer: 'http://' + domainSettings.domain + '/' + ( pagesName || '' ),
      domain: domainSettings.domain,
      lang: 'en',
      rule_set: formSettings.ruleset
    };

    const datepickerClass = classNames({
      'col-xs-6': true,
      'datepicker': true,
      'calendarEmbed': true
    });

    const liClass = classNames({
      'clearfix': true
    });

    const labelClass = classNames({
      'col-xs-6': true
    });

    const inputClass = classNames({
      'col-xs-6': true
    });

    const firstRoomClass = classNames({
      'room': true,
      'clearfix': true
    });

    const roomOneLabel = 'Room Type';

    return (
      <div className={ activeClass }>
        <form id="hotelParkingEngine" acceptCharset="UTF-8" action={ formSettings.hotelAction } className="hxEmbed clearfix" method={ formSettings.method }>

          <div className="options">
            <ul className="unstyled">

              { !hiddenLocation ?
                <li className={ liClass }>
                  <label className={ labelClass }>Flying from?</label>
                  <LocationDropDown className={ inputClass } activeLocation={ Location || formSettings.defaultHotelLocation } locations={ locations.hotels } />
                </li>
              :
                <input name="Location" type="hidden" className="l" value={ hiddenLocation } data-track-name="location" />
              }

              <li className={ firstRoomClass }>
                <label className={ labelClass }>{ roomOneLabel }</label>
                <RoomSelect className={ inputClass } name="RoomType[0]" RoomTypes={ RoomTypes } activeRoom={ defaultRoomType } pagesName={ pagesName } />
              </li>

              <li className={ liClass }>
                <label className={ labelClass }>Hotel stay for 1 night</label>
                <select ref={ ( c ) => this._pptsSelect = c } className={ inputClass } data-hxtrack-name="engine-hcp-ppts" name="ppts" defaultValue={ ppts } onChange={ this.flipPPTS }>
                  <option value="0">Before I fly</option>
                  <option value="1">On return</option>
                </select>
              </li>

              <li className={ liClass }>
                <label className={ labelClass }>{ arrivalDateText }</label>
                <div className={ datepickerClass }>
                  <input className="alternateDA col-xs-12 hxtrack" defaultValue={arrivalDateFormatted} />
                  <input className="dA" name="ArrivalDate" defaultValue={arrivalDate} type="hidden" />
                  <div />
                </div>
              </li>

              <li className={ liClass }>
                <label className={ labelClass }>{ departDateText }</label>
                <div className={ datepickerClass }>
                  <input className="alternateDD col-xs-12 hxtrack" defaultValue={departDateFormatted} />
                  <input className="dD" name="DepartDate" defaultValue={departDate} type="hidden" />
                  <div />
                </div>
              </li>

              { showFlight && (
                <FlightLookUp liClass={ liClass } labelClass={ labelClass } inputClass={ inputClass } tracking="engine-hcp-outbound-flight"/>
              )}

              <SearchButton searchText="Search" hideArrow={ true } />
            </ul>
          </div>

          <HiddenInputs inputs={ defaultInputs } />
          { engineSearchField && (
            <input name="search" type="hidden" value={ engineSearchField } />
          )}
          <HiddenInputs inputs={ hiddenInputs } />
        </form>
      </div>
    );
  }
});

module.exports = HotelParkingEngine;






// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/engines/hotel-parking-engine.jsx